module.exports = __webpack_public_path__ + "img/mont1.28106152.png";